var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{attrs:{"color":"white","fab":"","icon":"","x-small":""},on:{"mouseover":_vm.setHover,"mouseleave":_vm.leaveHover,"click":_vm.handleBarTag}},[_c('v-icon',{attrs:{"size":"25","color":"white"}},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }